import { render, staticRenderFns } from "./DashboardAppsRow.vue?vue&type=template&id=57864a4d&scoped=true&"
import script from "./DashboardAppsRow.vue?vue&type=script&lang=js&"
export * from "./DashboardAppsRow.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAppsRow.vue?vue&type=style&index=0&id=57864a4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57864a4d",
  null
  
)

export default component.exports